import styled, { css } from 'styled-components';
import { VAULT_DENSITIES } from '@utils/documentVault';

/*
  Shared between the table and the tree so a row reads the same in either view.
  Column widths are fixed here rather than per-component so headers and cells cannot drift.
*/
export const COLUMN_LAYOUT = css`
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr) 140px 180px 120px 100px 120px;
  align-items: center;
  gap: 16px;
`;

export const RowWrapper = styled.div`
  ${COLUMN_LAYOUT};

  padding: ${({ $density }) => ($density === VAULT_DENSITIES.compact ? '6px 8px' : '12px 8px')};
  border-bottom: 1px solid ${({ theme }) => theme.themeColors.lowContrastBorder};
  cursor: pointer;

  /* Selection tints the row so a click that only selects still visibly did something. */
  background: ${({ theme, $isSelected }) => ($isSelected ? theme.themeColors.hoverComponentBackground : 'transparent')};

  &:hover {
    background: ${({ theme, $isSelected }) =>
      $isSelected ? theme.themeColors.hoverComponentBackground : theme.themeColors.componentNoOpacity};
  }
`;

export const HeaderRowWrapper = styled.div`
  ${COLUMN_LAYOUT};

  padding: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.themeColors.border};
`;

export const CellWrapper = styled.div`
  min-width: 0;
`;
